import { Column } from '@tanstack/react-table';

import { FacetFilter } from '@/components/ui/data-table/facet-filter';
import { FilterData } from '@/components/ui/data-table/filter-toolbar';
import { StatusFilter, StatusFilterValue } from '@/components/ui/data-table/status-filter';
import { statusToString } from '@/components/ui/data-table/status-filter/utils';
import { TextFilter } from '@/components/ui/data-table/text-filter';

export interface TableFilterProps {
  column: Column<any, unknown>;
  filterData: FilterData;
}

const TableFilter = ({ column, filterData }: TableFilterProps) => {
  const { filterVariant, filterPlaceholder } = column.columnDef.meta ?? {};

  if (filterVariant === 'text') {
    const value = (column?.getFilterValue() as string) || '';
    return (
      <TextFilter
        value={value}
        onChange={(newValue) => column.setFilterValue(newValue)}
        placeholder={filterPlaceholder}
      />
    );
  }

  if (filterVariant === 'status') {
    const value = column?.getFilterValue() as StatusFilterValue;
    return (
      <StatusFilter
        placeholder={filterPlaceholder}
        selectedValue={statusToString(value)}
        value={value}
        onSearch={(newValue) => column.setFilterValue(newValue)}
      />
    );
  }

  const selectedValues = (column?.getFilterValue() as string[]) || [];
  return (
    <FacetFilter
      onChange={(newValue) => column.setFilterValue(newValue)}
      selectedValues={selectedValues}
      options={filterData[column.id]}
      placeholder={filterPlaceholder}
    />
  );
};
export { TableFilter };
